import { createReducer } from 'redux-act';
import Immutable from 'seamless-immutable';
import CollectionActions from './collection-actions';

const initialState = Immutable({
  isLoading:        false,
  collectionSearch: '',
  activeCollection: {},
  byId:             {},
  allIds:           [],
});

const reducer = createReducer(on => {
  on(
    [
      CollectionActions.fetchCollection,
      CollectionActions.fetchCollectionByExperience,
      CollectionActions.fetchCollections,
      CollectionActions.deleteCollection,
    ],
    state => state.set('isLoading', true)
  );

  on(
    [
      CollectionActions.fetchCollectionSuccess,
      CollectionActions.fetchCollectionByExperienceSuccess,
      CollectionActions.saveCollectionSuccess,
      CollectionActions.applyCollectionSuccess,
    ],
    (state, { collection }) => {
      const updatedState = state;
      const allIds = [collection.id].concat(_.without(updatedState.allIds, collection.id));
      return updatedState
        .setIn(['byId', [collection.id]], collection)
        .set('allIds', allIds)
        .set('isLoading', false);
    }
  );

  on(CollectionActions.fetchCollectionsSuccess, (state, { collections }) => {
    let byId = state.byId;
    let allIds = [];
    _.each(collections, collection => {
      allIds = allIds.concat([collection.id]);
      byId = byId.set(collection.id, collection);
    });

    return state
      .set('byId', byId)
      .set('allIds', allIds)
      .set('isLoading', false);
  });

  on(CollectionActions.deleteCollectionSuccess, (state, { collectionId }) => {
    return state
      .set('byId', state.byId.without(collectionId))
      .set('allIds', _.reject(state.allIds, id => id === collectionId))
      .set('isLoading', false);
  });

  on(
    [
      CollectionActions.fetchCollectionFailure,
      CollectionActions.fetchCollectionByExperienceFailure,
      CollectionActions.fetchCollectionsFailure,
      CollectionActions.saveCollectionFailure,
      CollectionActions.applyCollectionFailure,
      CollectionActions.deleteCollectionFailure,
    ],
    state => state.set('isLoading', false)
  );

  on(CollectionActions.setActiveCollection, (state, { collection }) => state.set('activeCollection', collection));

  on(CollectionActions.updateActiveCollection, (state, { collectionData }) =>
    state.merge({ activeCollection: { ...collectionData, editedTimestamp: Date.now() } }, { deep: true })
  );

  on(CollectionActions.updateCollectionSearch, (state, { search }) => state.set('collectionSearch', search));
}, initialState);

export default reducer;
